<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 mat-dialog-title appLifecycleTracker trackerName="edit-user-dialog">{{fHeader}}</h2>

<mat-dialog-content>
    <form class="edit-container" [formGroup]="editUserForm">
        <mat-form-field style="margin-top: 15px;" appearance="outline">
            <input matInput type="text" formControlName="username" placeholder="{{fUser}}" [value]="user.username" #usernameInput (blur)="onUsernameBlur()" />
        </mat-form-field>

        <div>
            <h3>{{fContact}}</h3>
            <mat-form-field appearance="outline">
                <input id="edit_user_email" matInput type="email" formControlName="email" placeholder="{{fEmail}}" [value]="user.email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" #emailInput (blur)="onEmailBlur()" />
                <mat-error *ngIf="f.email.errors?.required">{{'EMAIL_REQ' | translate}}</mat-error>
                <mat-error *ngIf="f.email.errors?.exists">{{'EMAIL_EXISTS' | translate}}</mat-error>
                <mat-error *ngIf="f.email.errors?.pattern">{{'APU_EMAIL_INVALID' | translate}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <input id="edit_user_fname" matInput type="text" formControlName="fname" placeholder="{{fFName}}" [value]="user.fname" maxlength="255" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <input id="edit_user_lname" matInput type="text" formControlName="lname" placeholder="{{fLName}}" [value]="user.lname" maxlength="255" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <input id="edit_user_zip" matInput type="text" formControlName="zip" placeholder="{{fZip}}" [value]="user.billing_zip_code" />
            </mat-form-field>

            <app-country-code-form-field id="edit_user_country_code_field"
                                         [zipCodeControl]="editUserForm.controls.zip"
                                         [formGroup]="editUserForm"></app-country-code-form-field>

            <div>
                <p>{{fSettings}}</p>
            </div>
            <div>
                <mat-checkbox id="edit_user_business_edition_checkbox" formControlName="business_edition" color="primary" value="user.business_edition" (change)="business_edition_changed($event)">
                    <mat-label>{{fPremium}}</mat-label>
                </mat-checkbox>
            </div>

        </div>

    </form>
</mat-dialog-content>
<div style="margin-top: 15px;">
    <mat-dialog-actions class="button-wrapper">
        <button id="edit_user_cancel_button" mat-raised-button (click)='cancel()'>{{fCancel}}</button>
        <button id="edit_user_save_button" mat-raised-button (click)='editUser()' color="primary" [disabled]="!editUserForm.valid">{{fSave}}</button>
    </mat-dialog-actions>
</div>
